export const HEADER_ITEM_IDS = {
  SETTINGS: 3,
  LOGOUT: 4,
};
